import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreHoriz = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "-2.4 -2.4 28.80 28.80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	transform: "rotate(90)",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_bgCarrier",
			strokeWidth: 0
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_tracerCarrier",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			stroke: "#BDC796",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_iconCarrier",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M3 10H21M3 14H21M3 18H21M3 6H21",
				stroke: "#BDC796",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		})
	]
});
export default SvgMoreHoriz;
